exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-templates-portfolio-query-js": () => import("./../../../src/templates/portfolio-query.js" /* webpackChunkName: "component---src-templates-portfolio-query-js" */)
}

